import { createActionTypes } from "@helpers/redux-helpers";

export const updateEmailActionTypes = createActionTypes("email/change");

export const clearChangeEmailStatesActionType = "email/clearStates";
